import styled from 'styled-components'

export const ModalOverlayWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(32, 32, 32, 0.95);
  z-index: 5;

  padding: 64px 48px 48px;

  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 949px) {
    padding: 0 24px;
  }

`

export const BoxModal = styled.div`
  width: 100%;
  max-width: 1280px;
  height: 100%;
  max-height: 543px;

  background-color: transparent;
  /* z-index: 2; */

  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;

  button {
    border: none;
    border-radius: 4px;
    background-color: unset;
    padding: 5px;
    cursor: pointer;

    top: -60px;
    right: 0;

    position: absolute;

    transition: background-color 0.2s;

    :hover {
      background-color: var(--orange);
    }
  }

  h1 {
    margin-top: 48px;
  }

  @media (max-width: 949px) {
    height: auto;
  }
`

export const Embed = styled.div`
  width: 100%;
  max-width: 966px;
  height: 100%;
  max-height: 543px;


  background-color: transparent;
  position: relative;

  /* padding-bottom: 56.25%; */
  padding-bottom: 42.25%;
  /* padding-top: 30px; */
  /* overflow: hidden; */

  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* z-index: 2; */
  }

  @media (max-width: 949px) {
    height: 40vh;
  }
`
